var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/constant/common.ts
var SeverityType = /* @__PURE__ */ ((SeverityType2) => {
  SeverityType2["ERROR"] = "error";
  SeverityType2["WARN"] = "warn";
  SeverityType2["INFO"] = "info";
  SeverityType2["AUTO_DETECT_ERROR"] = "autoDetectError";
  SeverityType2["PERFORMANCE"] = "performance";
  SeverityType2["SPEED"] = "speed";
  SeverityType2["AUTO_DETECT_EVENT"] = "autoDetectEvent";
  return SeverityType2;
})(SeverityType || {});
var PlatformType = /* @__PURE__ */ ((PlatformType2) => {
  PlatformType2["android"] = "android";
  PlatformType2["ios"] = "ios";
  PlatformType2["windows"] = "windows";
  PlatformType2["macos"] = "macos";
  PlatformType2["linux"] = "linux";
  PlatformType2["other"] = "other";
  return PlatformType2;
})(PlatformType || {});
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["production"] = "prod";
  Environment2["demo"] = "demo";
  Environment2["staging"] = "staging";
  return Environment2;
})(Environment || {});
var NetworkType = /* @__PURE__ */ ((NetworkType2) => {
  NetworkType2["unknown"] = "unknown";
  NetworkType2["wifi"] = "wifi";
  NetworkType2["net2g"] = "net2g";
  NetworkType2["net3g"] = "net3g";
  NetworkType2["net4g"] = "net4g";
  NetworkType2["net5g"] = "net5g";
  return NetworkType2;
})(NetworkType || {});

// src/constant/config.ts
var UNKNOWN_VALUE = "airTracker_unknown";
var DEFAULT_CONFIG = {
  appName: UNKNOWN_VALUE,
  appVersion: UNKNOWN_VALUE,
  env: "staging" /* staging */,
  isWebappContainer: false,
  delay: 2e3,
  errorRepeatTime: 3,
  enableErrorMonitoring: false,
  enableWebVitals: false,
  assetSpeedMonitoringWhiteList: [],
  enableDetectPageChange: false,
  assetSpeedMonitoringWhiteListByMFE: {}
};
var DEFAULT_COMMON_DATA = {
  appName: UNKNOWN_VALUE,
  env: "staging" /* staging */,
  sessionId: UNKNOWN_VALUE,
  deviceId: UNKNOWN_VALUE,
  platform: "other" /* other */
};

// src/util/jsonHelper.ts
var isJSON = (str) => {
  if (!str) {
    return false;
  }
  if (/^\s*$/.test(str))
    return false;
  str = str.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@");
  str = str.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]");
  str = str.replace(/(?:^|:|,)(?:\s*\[)+/g, "");
  return /^[\],:{}\s]*$/.test(str);
};
var safeReplacer = () => {
  const seen = /* @__PURE__ */ new WeakSet();
  return (key, value) => {
    if (value instanceof Error) {
      return `Error.message: ${value.message} 
  Error.stack: ${value.stack}`;
    }
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return `[Circular ${key || "root"}]`;
      }
      seen.add(value);
    }
    if (typeof value === "function") {
      return "function";
    }
    if (typeof value === "symbol") {
      return "symbol";
    }
    if (typeof value === "undefined") {
      return null;
    }
    return value;
  };
};
var safeStringify = (obj) => {
  if (typeof obj === "string") {
    return obj;
  }
  try {
    if (obj instanceof Error) {
      return (JSON.stringify(obj, safeReplacer()) || "undefined").replace(/"/gim, "");
    }
    return JSON.stringify(obj, safeReplacer());
  } catch (e) {
    return '{"error":"error happen when airTracker stringify"}';
  }
};

// src/util/http.ts
var request = ({ method = "post", url, data, success, fail }) => {
  if (!isJSON(data)) {
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.addEventListener("readystatechange", () => {
    if (xhr.readyState === 4) {
      if (xhr.status >= 400 || xhr.status === 0) {
        fail == null ? void 0 : fail(xhr.response);
      } else {
        success == null ? void 0 : success(xhr.response);
      }
    }
  });
  xhr.open(method, url);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(data);
};

// src/constant/lifeCycleEventName.ts
var lifeCycleEventName = {
  onInit: "onInit",
  onConfigInit: "onConfigInit",
  onConfigUpdated: "onConfigUpdated",
  onCommonDataInit: "onCommonDataInit",
  onCommonUpdated: "onCommonUpdated",
  onPageChange: "onPageChange",
  onDestroy: "onDestroy,"
};

// src/constant/index.ts
var DEVICE_ID_STORAGE_KEY = "AIR_ANALYTICS_DEVICE_ID";
var loggingServiceCorsUrl = (env) => {
  if (env == "prod" /* production */) {
    return "https://api.airwallex.com/papluginlogs/cors-logs";
  }
  if (env == "demo" /* demo */) {
    return "https://api-demo.airwallex.com/papluginlogs/cors-logs";
  }
  return "https://api-staging.airwallex.com/papluginlogs/cors-logs";
};
var loggingServicePublishUrl = (env) => {
  if (env == "prod" /* production */) {
    return "https://api.airwallex.com/papluginlogs/logs";
  }
  if (env == "demo" /* demo */) {
    return "https://api-demo.airwallex.com/papluginlogs/logs";
  }
  return "https://api-staging.airwallex.com/papluginlogs/logs";
};

// src/util/index.ts
var generateUId = () => {
  const deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
  return deviceId;
};
var getMFEName = () => {
  var _a, _b;
  return ((_b = (_a = location == null ? void 0 : location.pathname) == null ? void 0 : _a.split("/")) == null ? void 0 : _b[2]) || "unknown";
};
var getDeviceId = () => {
  try {
    let deviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (!deviceId) {
      deviceId = generateUId();
      window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    }
    return deviceId;
  } catch (e) {
  }
};
var getPlatform = () => {
  const platformRegExp = {
    android: /\bAndroid\s*([^;]+)/,
    ios: /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,
    windows: /\b(Windows NT)/,
    macos: /\b(Mac OS)/,
    linux: /\b(Linux)/i
  };
  const isMatchPlatform = (platform) => platformRegExp[platform].test(navigator.userAgent);
  const matchPlatform = Object.keys(platformRegExp).find(isMatchPlatform);
  return matchPlatform ? PlatformType[matchPlatform] : "other" /* other */;
};
var isAirwallexDomain = () => {
  return /^[a-zA-Z0-9.-]*.airwallex.com$/g.test(window.location.host);
};
var getNetworkType = () => {
  var _a, _b;
  let netType = "";
  const arr = navigator.userAgent.match(/NetType\/(\w+)/);
  if (arr) {
    [, netType] = arr;
  } else if (navigator == null ? void 0 : navigator.connection) {
    netType = // @ts-ignore:next-line
    ((_a = navigator == null ? void 0 : navigator.connection) == null ? void 0 : _a.effectiveType) || ((_b = navigator == null ? void 0 : navigator.connection) == null ? void 0 : _b.type);
  }
  if (!netType) {
    netType = "unknown";
  }
  return parseNetType(netType);
};
var parseNetType = (net) => {
  net = String(net).toLowerCase();
  if (net.indexOf("4g") >= 0)
    return "net4g" /* net4g */;
  if (net.indexOf("wifi") >= 0)
    return "wifi" /* wifi */;
  if (net.indexOf("5g") >= 0)
    return "net5g" /* net5g */;
  if (net.indexOf("3g") >= 0)
    return "net3g" /* net3g */;
  if (net.indexOf("2g") >= 0)
    return "net2g" /* net2g */;
  return "unknown" /* unknown */;
};
var canUseResourceTiming = function() {
  return typeof window.performance !== "undefined" && typeof window.performance.clearResourceTimings === "function" && typeof window.performance.getEntriesByType === "function" && typeof window.performance.now === "function";
};
var canUseWebVitals = function() {
  return typeof window.PerformanceObserver === "function";
};
var formatUrl = (url) => {
  if (typeof url === "string") {
    const hostUrl = url.split("?")[0] || "";
    return hostUrl.slice(0, 200);
  }
  return url;
};
var getQueryString = (url) => {
  if (typeof url === "string") {
    return url.split("?")[1] || "";
  }
  return url;
};
var urlIsHttps = (url) => {
  const isHostProtocol = typeof url === "string" && url.startsWith("//");
  return isHostProtocol ? typeof location !== "undefined" && location.protocol === "https:" : /^https/.test(url);
};
var getReportVal = (rawVal, isDefaultByString) => {
  if (typeof rawVal === "number") {
    return rawVal;
  }
  if (typeof rawVal === "string") {
    return rawVal;
  }
  return isDefaultByString ? "" /* string */ : -1 /* number */;
};
var checkIfInWhiteList = (url, airTracker2) => {
  var _a;
  let isInWhiteList = false;
  if (!airTracker2.config.isWebappContainer) {
    isInWhiteList = checkIfInWhiteListHelper(url, airTracker2.config.assetSpeedMonitoringWhiteList);
    return isInWhiteList;
  }
  const MFEName = getMFEName();
  return isInWhiteList || checkIfInWhiteListHelper(url, (_a = airTracker2.config.assetSpeedMonitoringWhiteListByMFE) == null ? void 0 : _a[MFEName]);
};
var checkIfInWhiteListHelper = (url, whiteList) => {
  if (!(whiteList == null ? void 0 : whiteList.length)) {
    return false;
  }
  for (let i = 0; i < whiteList.length; i++) {
    const cur = whiteList[i];
    if (cur instanceof RegExp && cur.test(url)) {
      return true;
    }
    if (typeof cur == "string" && url.includes(cur)) {
      return true;
    }
  }
  return false;
};

// src/pipes/send.ts
var sendNormalLogPipe = (airTracker2) => {
  return (logs) => {
    var _a;
    const commonData = airTracker2.config.isWebappContainer ? __spreadValues(__spreadValues({}, airTracker2.commonData || {}), ((_a = airTracker2.MFECommonDataMap) == null ? void 0 : _a[getMFEName()]) || {}) : airTracker2.commonData;
    const finalLog = {
      commonData,
      data: Array.isArray(logs) ? logs : [logs]
    };
    const dataBody = safeStringify(finalLog);
    const sendOptions = {
      method: "post",
      url: isAirwallexDomain() ? loggingServiceCorsUrl(airTracker2.commonData.env) : loggingServicePublishUrl(airTracker2.commonData.env),
      data: dataBody
    };
    request(sendOptions);
  };
};

// src/pipes/throttle.ts
var throttlePipe = (airTracker2, maxLength) => {
  let timer;
  const retainedLogs = [];
  const { config } = airTracker2;
  return (log, resolve) => {
    retainedLogs.push(log);
    airTracker2.lifeCycle.on(lifeCycleEventName.onCommonUpdated, () => {
      if (retainedLogs.length > 0) {
        resolve == null ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
        airTracker2.lifeCycle.remove(lifeCycleEventName.onCommonUpdated);
        timer && clearTimeout(timer);
      }
    });
    if (maxLength && retainedLogs.length >= maxLength) {
      resolve == null ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
      timer && clearTimeout(timer);
      return;
    }
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (retainedLogs.length > 0) {
        resolve == null ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
        airTracker2.lifeCycle.remove(lifeCycleEventName.onCommonUpdated);
      }
    }, config.delay);
  };
};

// src/pipes/errorRepeatLimit.ts
var errorLogLimitPipe = (airTracker2) => {
  const errorLogMap = {};
  return (logs, resolve) => {
    const maxNum = typeof airTracker2.config.errorRepeatTime === "number" ? airTracker2.config.errorRepeatTime : 5;
    if (maxNum === 0) {
      return resolve == null ? void 0 : resolve(logs);
    }
    resolve == null ? void 0 : resolve(
      logs.filter((log) => {
        if (log.severity == "autoDetectError" /* AUTO_DETECT_ERROR */) {
          errorLogMap[log.error] = errorLogMap[log.error] || 0;
          errorLogMap[log.error] += 1;
          if (errorLogMap[log.error] > maxNum) {
            return false;
          }
          return true;
        }
        return true;
      })
    );
  };
};

// src/pipes/index.ts
var noop = () => {
};
var createPipeline = (pipeArr) => {
  if (!pipeArr || !pipeArr.reduce || !pipeArr.length) {
    throw new TypeError("createPipeline need at least one function param");
  }
  if (pipeArr.length === 1) {
    return (msg, resolve) => {
      pipeArr[0](msg, resolve || noop);
    };
  }
  return pipeArr.reduce(
    (prePipe, pipe) => (msg, nextPipe = noop) => prePipe(msg, (msg2) => pipe == null ? void 0 : pipe(msg2, nextPipe))
  );
};

// src/util/eventEmitter.ts
var EventEmitter = class {
  constructor() {
    this.emit = (name, data) => {
      if (!this)
        return;
      let events = this.eventsList[name];
      let handler;
      if (events == null ? void 0 : events.length) {
        events = events.slice();
        for (let i = 0; i < events.length; i++) {
          handler = events[i];
          try {
            const result = handler.callback.apply(this, [data]);
            if (1 === handler.type) {
              this.remove(name, handler.callback);
            }
            if (false === result) {
              break;
            }
          } catch (e) {
            throw e;
          }
        }
      }
      return this;
    };
    this.eventsList = {};
  }
  indexOf(array, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].callback === value) {
        return i;
      }
    }
    return -1;
  }
  on(name, callback, type = 0) {
    if (!this)
      return;
    let events = this.eventsList[name];
    if (!events) {
      this.eventsList[name] = [];
      events = this.eventsList[name];
    }
    if (this.indexOf(events, callback) === -1) {
      const handler = {
        name,
        type: type || 0,
        callback
      };
      events.push(handler);
      return this;
    }
    return this;
  }
  one(name, callback) {
    this.on(name, callback, 1);
  }
  remove(name, callback) {
    if (!this)
      return;
    const events = this.eventsList[name];
    if (!events) {
      return null;
    }
    if (!callback) {
      try {
        delete this.eventsList[name];
      } catch (e) {
      }
      return null;
    }
    if (events.length) {
      const index = this.indexOf(events, callback);
      events.splice(index, 1);
    }
    return this;
  }
  clear() {
    this.eventsList = {};
  }
};

// src/interface/plugins.ts
var AirTrackerPlugin = class {
  constructor(pluginOption) {
    this.name = "";
    // initiation flag
    this.isInit = false;
    this.name = pluginOption.name;
    this.option = pluginOption;
  }
  patch(airTracker2) {
    var _a, _b;
    if (!this.isInit) {
      this.isInit = true;
      (_b = (_a = this.option) == null ? void 0 : _a.setUp) == null ? void 0 : _b.call(this.option, airTracker2);
    }
  }
  uninstall() {
    var _a, _b;
    (_b = (_a = this.option) == null ? void 0 : _a.destroy) == null ? void 0 : _b.apply(this);
    this.isInit = false;
  }
};

// src/plugins/onErrorPlugin.ts
var airTracker;
var onError = (event) => {
  const errString = `${safeStringify(event.message) || ""} @ (${safeStringify(event.filename) || ""}:${event.lineno || 0}:${event.colno || 0})
${safeStringify(event.error || "")}`;
  airTracker.normalLogPipeLine({
    severity: "autoDetectError" /* AUTO_DETECT_ERROR */,
    eventName: "windowOnError" /* windowOnError */,
    extraInfo: {
      error: errString
    }
  });
};
var unhandledrejectionHandler = (event) => {
  const reason = event && safeStringify(event.reason);
  airTracker.normalLogPipeLine({
    severity: "autoDetectError" /* AUTO_DETECT_ERROR */,
    eventName: "promiseError" /* promiseError */,
    extraInfo: {
      error: reason
    }
  });
};
var errorHandler = (event) => {
  const target = (event == null ? void 0 : event.target) || (event == null ? void 0 : event.srcElement);
  if (!target) {
    return;
  }
  const url = (target == null ? void 0 : target.src) || (target == null ? void 0 : target.href);
  const { tagName } = target;
  let staticFileType = "unknown" /* unknown */;
  if (typeof url === "string" && tagName) {
    if (window.location.href.indexOf(url) > -1) {
      return;
    }
    if (/\.js$/.test(url)) {
      staticFileType = "script" /* script */;
    } else if (/\.css$/.test(url)) {
      staticFileType = "css" /* css */;
    } else {
      switch (tagName.toLowerCase()) {
        case "script":
          staticFileType = "script" /* script */;
          break;
        case "link":
          staticFileType = "css" /* css */;
          break;
        case "img":
          staticFileType = "image" /* img */;
          break;
        case "audio":
        case "video":
          staticFileType = "media" /* media */;
          break;
        default:
          return;
      }
    }
    airTracker.normalLogPipeLine({
      severity: "autoDetectError" /* AUTO_DETECT_ERROR */,
      eventName: "staticFileLoadError" /* staticFileLoadError */,
      extraInfo: {
        staticFileType,
        error: `${tagName} load fail: ${url}`
      }
    });
  }
};
var errorDetectionPlugin = new AirTrackerPlugin({
  name: "errorDetectionPlugin",
  setUp: (airTrackerInst) => {
    airTracker = airTrackerInst;
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", unhandledrejectionHandler);
    window.document.addEventListener("error", errorHandler, true);
  },
  destroy: () => {
    window.removeEventListener("unhandledrejection", unhandledrejectionHandler);
    window.document.removeEventListener("error", errorHandler, true);
    window.removeEventListener("error", onError);
  }
});

// src/plugins/webVitalsPlugin.ts
import { onLCP, onFID, onCLS } from "web-vitals";
var webVitalsPlugin = new AirTrackerPlugin({
  name: "webVitalsPlugin",
  setUp: (airTracker2) => __async(void 0, null, function* () {
    if (!canUseResourceTiming() || !canUseWebVitals()) {
      return;
    }
    const report = (log) => {
      const { name, navigationType, rating, value } = log;
      airTracker2.normalLogPipeLine({
        severity: "performance" /* PERFORMANCE */,
        eventName: name,
        // LCP, FID, CLS
        extraInfo: {
          log: { navigationType, rating, value }
        }
      });
    };
    onCLS(report);
    onFID(report);
    onLCP(report);
  })
});

// src/plugins/assetsSpeedPlugin.ts
var ASSETS_INITIATOR_TYPE = ["img", "css", "script", "link", "audio", "video", "iframe"];
var COLLECTED_ENTRY_TYPE = "resource";
var generateSpeedLog = (entry) => {
  const resourceURl = entry.name;
  return {
    url: formatUrl(resourceURl),
    method: "get",
    // duration = redirect + DNS + CONNECTION + request + response
    duration: Number(entry.duration.toFixed(2)),
    // time it takes to load
    type: "static",
    isHttps: urlIsHttps(resourceURl),
    urlQuery: getQueryString(resourceURl),
    domainLookup: getReportVal(entry.domainLookupEnd - entry.domainLookupStart),
    connectTime: getReportVal(entry.connectEnd - entry.connectStart)
    // TCP/TLS/QUIC timing
  };
};
var publishSpeedLogs = (entries, airTracker2) => {
  for (let i = 0, l = entries.length; i < l; i++) {
    const entry = entries[i];
    if (ASSETS_INITIATOR_TYPE.indexOf(entry.initiatorType) !== -1 && checkIfInWhiteList(entry.name, airTracker2)) {
      airTracker2.normalLogPipeLine({
        severity: "performance" /* PERFORMANCE */,
        eventName: "assets_speed" /* ASSETS_SPEED */,
        extraInfo: {
          log: generateSpeedLog(entry)
        }
      });
    }
  }
};
var interval;
var observer;
var assetSpeedPlugin = new AirTrackerPlugin({
  name: "assetsSpeedPlugin",
  setUp: (airTracker2) => {
    if (!canUseResourceTiming())
      return;
    let collectCur = 0;
    window.performance.onresourcetimingbufferfull = () => {
      collectCur = 0;
      window.performance.clearResourceTimings();
    };
    if (typeof window.PerformanceObserver === "function") {
      publishSpeedLogs(window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE), airTracker2);
      observer = new window.PerformanceObserver((list) => {
        publishSpeedLogs(list.getEntries(), airTracker2);
      });
      observer.observe({ entryTypes: [COLLECTED_ENTRY_TYPE] });
    } else {
      interval = setInterval(() => {
        const allEntries = window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE);
        const collectEntries = allEntries.slice(collectCur);
        collectCur = allEntries.length;
        publishSpeedLogs(collectEntries, airTracker2);
      }, 3e3);
    }
  },
  destroy: () => {
    observer == null ? void 0 : observer.disconnect();
    interval && clearInterval(interval);
  }
});

// src/plugins/onPageChangePlugin.ts
var observer2;
var onPageChangePlugin = new AirTrackerPlugin({
  name: "onPageChangePlugin",
  setUp: (airTracker2) => __async(void 0, null, function* () {
    let previousUrl = location == null ? void 0 : location.href;
    const body = document.querySelector("body");
    observer2 = new MutationObserver(() => {
      if (location.href !== previousUrl) {
        const tempPreviousUrl = previousUrl;
        previousUrl = location.href;
        airTracker2.normalLogPipeLine({
          severity: "autoDetectEvent" /* AUTO_DETECT_EVENT */,
          eventName: "onPageChange" /* onPageChange */,
          extraInfo: {
            prevHref: tempPreviousUrl,
            href: (location == null ? void 0 : location.href) || "",
            hostname: location == null ? void 0 : location.hostname,
            pathName: location == null ? void 0 : location.pathname,
            protocol: location == null ? void 0 : location.protocol,
            search: location == null ? void 0 : location.search
          }
        });
      }
    });
    const config = { subtree: true, childList: true };
    observer2.observe(body || document, config);
  }),
  destroy: () => {
    observer2 == null ? void 0 : observer2.disconnect();
  }
});

// src/airTracker.ts
var AirTracker = class {
  constructor({ config, plugins = [] }) {
    this.config = DEFAULT_CONFIG;
    this.lifeCycle = new EventEmitter();
    this.plugins = [];
    this._commonData = DEFAULT_COMMON_DATA;
    this._MFECommonDataMap = {};
    // customized speed log
    this.timeMap = {};
    this.normalPipelineObj = createPipeline([throttlePipe(this, 8), errorLogLimitPipe(this), sendNormalLogPipe(this)]);
    this.normalLogPipeLine = ({
      severity,
      eventName,
      extraInfo
    }) => {
      const packedData = __spreadValues({
        severity,
        eventName,
        currentHref: (location == null ? void 0 : location.href) || "unknown href"
      }, extraInfo);
      if (this.config.isWebappContainer) {
        packedData.MFEName = getMFEName();
      }
      return this.normalPipelineObj(packedData);
    };
    this.plugins = [...plugins];
    this.setConfig(config);
    this.initCommonData(config);
    this.lifeCycle.emit(lifeCycleEventName.onInit);
    if (config.enableErrorMonitoring) {
      this.plugins.push(errorDetectionPlugin);
    }
    if (config.enableWebVitals) {
      this.plugins.push(webVitalsPlugin);
    }
    if ((config == null ? void 0 : config.assetSpeedMonitoringWhiteList) && config.assetSpeedMonitoringWhiteList.length > 0 || config.isWebappContainer) {
      this.plugins.push(assetSpeedPlugin);
    }
    if (config == null ? void 0 : config.enableDetectPageChange) {
      this.plugins.push(onPageChangePlugin);
    }
    this.installPlugins();
  }
  installPlugins() {
    this.plugins.forEach((item) => {
      item.patch(this);
    });
  }
  get commonData() {
    return this._commonData;
  }
  get MFECommonDataMap() {
    return this._MFECommonDataMap;
  }
  initCommonData(config) {
    this._commonData.sessionId = generateUId();
    this._commonData.deviceId = getDeviceId() || UNKNOWN_VALUE;
    this._commonData.platform = getPlatform();
    this._commonData.networkType = getNetworkType() || "unknown" /* unknown */;
    this._commonData.env = config.env || this._commonData.env;
    this._commonData.accountId = config.accountId || UNKNOWN_VALUE;
    this._commonData.appVersion = config.appVersion;
    this._commonData.appName = config.appName;
    this.lifeCycle.emit(lifeCycleEventName.onCommonDataInit, this.commonData);
  }
  updateCommonDataBasedOnConfig(config) {
    this._commonData.env = config.env || this._commonData.env;
    this._commonData.appName = config.appName || this._commonData.appName;
    this._commonData.env = config.env || this._commonData.env;
    this._commonData.accountId = config.accountId || this._commonData.accountId;
    this._commonData.appVersion = config.appVersion || this._commonData.appVersion;
    this.lifeCycle.emit(lifeCycleEventName.onCommonUpdated, this._commonData);
  }
  // Can add extra common data based on developers' needs
  updateCommonData(extraData) {
    this._commonData = __spreadValues(__spreadValues({}, this._commonData), extraData);
  }
  // only worked if isWebappContainer is true
  addToMFECommonData({ MFEName, MFECommonData }) {
    var _a;
    if (!this.config.isWebappContainer) {
      return;
    }
    if (!MFEName || !MFECommonData) {
      return;
    }
    this._MFECommonDataMap = __spreadProps(__spreadValues({}, this._MFECommonDataMap || {}), {
      [MFEName]: __spreadValues(__spreadValues({}, ((_a = this._MFECommonDataMap) == null ? void 0 : _a[MFEName]) || {}), MFECommonData)
    });
  }
  // support set config later
  setConfig(config) {
    if (this.config.isWebappContainer) {
      return;
    }
    const setValue = (key, value) => {
      this.config[key] = value;
    };
    Object.entries(config).forEach((item) => {
      const [key, val] = item;
      if (typeof val !== void 0) {
        setValue(key, val);
      }
    });
    this.lifeCycle.emit(lifeCycleEventName.onConfigInit, this.config);
    this.updateCommonDataBasedOnConfig(config);
  }
  // send info level log
  info(eventName, extraInfo) {
    this.normalLogPipeLine({
      severity: "info" /* INFO */,
      eventName,
      extraInfo
    });
  }
  // send warn level log
  warn(eventName, extraInfo) {
    this.normalLogPipeLine({
      severity: "warn" /* WARN */,
      eventName,
      extraInfo
    });
  }
  // send error level log
  error(eventName, extraInfo) {
    this.normalLogPipeLine({
      severity: "error" /* ERROR */,
      eventName,
      extraInfo
    });
  }
  // send business related log, usually used for data analysis
  // in the future, all the logs with isBusinessData == true, will be sync to bigQuery / looker
  businessLog(eventName, extraInfo) {
    this.normalLogPipeLine({
      severity: "info" /* INFO */,
      eventName,
      extraInfo: __spreadProps(__spreadValues({}, extraInfo), {
        isBusinessLog: true
      })
    });
  }
  // duration: milliseconds
  reportDuration(eventName, duration) {
    if (typeof eventName !== "string") {
      console.warn("reportDuration: eventName (first param) must be a string");
      return;
    }
    if (typeof duration !== "number") {
      console.warn("reportDuration: duration (second param) must be number");
      return;
    }
    if (duration < 0 || duration > 6e4) {
      console.warn("reportDuration: duration (second param) must between 0 and 60000");
      return;
    }
    this.normalLogPipeLine({
      severity: "speed" /* SPEED */,
      eventName,
      extraInfo: {
        duration
      }
    });
  }
  getTimerKey(eventName) {
    return this.config.isWebappContainer ? `${getMFEName()}_${eventName}` : eventName;
  }
  timeStart(eventName) {
    if (typeof eventName !== "string") {
      console.warn("time: first param must be a string");
      return;
    }
    if (this.timeMap[this.getTimerKey(eventName)]) {
      console.warn(`Timer ${eventName} already exists`);
    }
    this.timeMap[this.getTimerKey(eventName)] = Date.now();
  }
  timeEnd(eventName, delta) {
    if (typeof eventName !== "string") {
      console.warn("timeEnd: first param must be a string");
      return;
    }
    if (this.timeMap[this.getTimerKey(eventName)]) {
      const duration = Date.now() - this.timeMap[this.getTimerKey(eventName)] + (delta || 0);
      this.normalLogPipeLine({
        severity: "speed" /* SPEED */,
        eventName,
        extraInfo: {
          duration
        }
      });
      delete this.timeMap[this.getTimerKey(eventName)];
    } else {
      console.warn(`Timer key :${eventName} does not exist`);
    }
  }
  // only worked if isWebappContainer is true
  addToAssetSpeedWhiteListByMFE({ MFEName, whiteList }) {
    var _a, _b, _c;
    if (!this.config.isWebappContainer) {
      return;
    }
    if (!MFEName || !(whiteList == null ? void 0 : whiteList.length)) {
      return;
    }
    if (!this.config.assetSpeedMonitoringWhiteListByMFE) {
      this.config.assetSpeedMonitoringWhiteListByMFE = {};
    }
    if (!((_a = this.config.assetSpeedMonitoringWhiteListByMFE) == null ? void 0 : _a[MFEName])) {
      this.config.assetSpeedMonitoringWhiteListByMFE = __spreadProps(__spreadValues({}, this.config.assetSpeedMonitoringWhiteListByMFE), {
        [MFEName]: whiteList
      });
    } else {
      (_c = (_b = this.config.assetSpeedMonitoringWhiteListByMFE) == null ? void 0 : _b[MFEName]) == null ? void 0 : _c.push(...whiteList);
    }
  }
  // please call destroy from your app root component when your app unmount
  destroy() {
    if (this.config.isWebappContainer) {
      return;
    }
    this.plugins.forEach((item) => {
      item.uninstall();
    });
  }
};

// src/index.ts
var src_default = AirTracker;
export {
  Environment,
  NetworkType,
  PlatformType,
  SeverityType,
  src_default as default
};
